export const preventBubbling = (e: React.MouseEvent) => {
  e.preventDefault();
  e.stopPropagation();
};
